import React,{useEffect, useState} from 'react';
import ModalLyt from '../../../../components/Layouts/ModalLyt/ModalLyt';
import { Grid,Box,Typography,Button,Tooltip } from '@mui/material';
import { useSelector,useDispatch } from 'react-redux';
// import { setOkrDeleteStateR } from '../../OKRManageSlice/OKRManageSlice';
import "../../../CompanyManagment/Copmonents/Like/Like.css";
// import { column, from } from 'stylis';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
// import PersonIcon from '@mui/icons-material/Person';
import Divider from "@mui/material/Divider";
import { useDisLikeMeeting, useLikeMeeting } from '../../Hooks';
import SubAlignmentKrCart from '../SubAlignmentKrCart/SubAlignmentKrCart';
import CommentModal from '../../../TenantDash/LComponents/AllTenantDash/AnotherComponent ';

const AlignmentKrCart = (props:any) => {
  // const dispatch=useDispatch();
  const deleteOkrState=useSelector((state:any)=>state.okrManage.okrDeleteData);
  const{mutate:likeKr,data:likeData}=useLikeMeeting()
  const{mutate:disLikeKr,data:disLikeData}=useDisLikeMeeting()
  const [showToastMessage, setShowToastMessage] = useState<any>(false);
  // const[showTransfer,setShowTransfer]=useState<Boolean>(false);
  // const userId=useSelector((state:any)=>state.loign.userInfo.userId);
  const tenantId=useSelector((state:any)=>state.meetings.profileTenantId);
  const [activeBtn, setActiveBtn] = useState<string>("none");

  // const afterSuccessDelete=()=>{
  //   // setTimeout(() => {
  //   //   dispatch(setOkrDeleteStateR(null))
  //   // }, 3000);
  // }
//   const{mutate:callDeleteKr,data:deleteData,isSuccess}=useDeleteKr()
  let{item,setKrId,setIteam,setShowEditKr,setAddKrState,personPicture,meetingId}=props;
  let{name,okrStateName,responsibleName ,id,liked,likeCount,commentCount, periodId, definitionLevelId,responsibleId,
       keyResultCheckingMeetingQueryResultDto}:any=item;

  const [likec, setLikeCount] = useState<number>(likeCount);

// const initialTransferShowDet=()=>{
//   setShowTransfer(true);
// }

// const initialDeleteKr=()=>{
//   let deleteBody={
//     deletedId:id,
//     userId:userId,
//     tenantId:tenantId
// }
// callDeleteKr(deleteBody)
// handleClose();
// }


// useEffect(() => {
  
//   setTimeout(() => {
//     dispatch(setOkrDeleteStateR(null))
// }, 3000);

// }, [deleteOkrState])


const initialLikeKr=()=>{
  let deleteBody={
  keyResultId:id,
  tenantId:tenantId
  }
  likeKr(deleteBody)
  }

  const initialDisLikeKr=()=>{
    let deleteBody={
    keyResultId:id,
    tenantId:tenantId
    }
    disLikeKr(deleteBody)
    }

    useEffect(() => {
      if (item) {
        setLikeCount(likeCount)
        if (liked) {
          setActiveBtn("like");
        }
      }
    }, likeCount)

    const handleReactionClick = (reaction: string): void => {
      if (activeBtn === "none") {
         if (reaction === "like") {
          setLikeCount(likec + 1);
          setActiveBtn("like");
          initialLikeKr();
        }
      } else if (activeBtn === reaction) {
        if (reaction === "like") {
          setLikeCount(likec - 1);
          initialDisLikeKr();
        }
        setActiveBtn("none");
      } 
      else if (activeBtn !== reaction) {
        if (reaction === "like") {
          setActiveBtn("like");
        }
      }
    };    
    const [open, setOpen] = React.useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  
  return (
    < >
             <Grid container boxShadow={4} borderRadius={4} p={2} >
            <Grid item xs={12}  >
           <Grid container alignItems={'center'} >
           <Grid item xs={12} sm={12}  >
            <Box    display={'flex'} 
        width={'100%'}
        alignItems={'start'}
        minHeight={'60px'} 
        justifyContent={'space-between'}
        >
          <Box display={'flex'}>        
            {
                  name.length > 65 ? <Tooltip  sx={{ fontSize: '1.5rem !important' }} title={name}>
              <Typography 
                mt={1} 
                textAlign={'left'}   
                variant='body1'
                sx={{ fontSize: '13px !important', fontWeight:'600',color: 'black',cursor:'pointer'}}   
              >
                نتیجه کلیدی: {name.slice(0,65)}
              </Typography>
            </Tooltip> : 
            <Typography mt={1} textAlign={'left'} sx={{ fontSize: '13px !important',fontWeight:'600', color: 'black',cursor:'pointer'}}    >
              نتیجه کلیدی: {name}
            </Typography>
       }
          </Box>
          <Box display={'flex'} justifyContent={'start'}  >

             <Typography variant='body2' fontWeight={700} >مسئول : </Typography>
                             <Box display={'flex'} justifyContent={'start'}  >
                             <img src={
                  personPicture !== null && personPicture !== undefined &&
                  personPicture.filter((x:any)=>x.personId === responsibleId)[0] !== null &&
                  personPicture.filter((x:any)=>x.personId === responsibleId)[0]!== undefined
                  ?
                  personPicture.filter((x:any)=>x.personId === responsibleId)[0].pictureBase64String
                  :''
                } width={'20px'} height={'20px'} style={{borderRadius:'50%'}} />
             <Typography variant='body2' fontWeight={500} px={0.5}  >
                 {
                    responsibleName
                 }
                </Typography>
                            </Box>

            </Box>
            <Box display={'flex'} alignItems={'center'}>
    <Box mr={2}>
      <CommentModal id={id} name={name} commentCount={commentCount} meetingId={meetingId}/>
    </Box>
  </Box>
           </Box>
           <Divider />
            </Grid>
           </Grid>
            </Grid>
            
            <Grid container  >
            {keyResultCheckingMeetingQueryResultDto !== null && keyResultCheckingMeetingQueryResultDto
             !== undefined && 
             keyResultCheckingMeetingQueryResultDto.map((item: any, i: number) => {
                      return (
                        <Grid item xs={12} sm={4}>
                          <Box
                              key={i}
                              sx={{
                                transition: "all 0.3s ease",
                                "&:hover": {
                                  transform: "scale(1.05)",
                                  backgroundColor: "withesmoke",
              
                                },
                                padding: "10px",
                                backgroundColor: "withesmoke",
                              }}
                            >
                            <SubAlignmentKrCart
                              setKrId={setKrId} 
                              meetingId={meetingId}
                              setShowToastMessage={setShowToastMessage}
                              personPicture={personPicture}
                              item={item}
                            />
                          </Box>
                        </Grid>
                      );
            })}
            </Grid>
            </Grid>
        </>
  )
}

export default AlignmentKrCart